import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {ReactComponent as Logo} from '../../assets/images/ugcan-logo.svg';

const RegistrationStatus = ({ email, status = 'pending', onClose }) => {
  const navigate = useNavigate();
  const [showResend, setShowResend] = useState(false);

  const buttonClass = `m-2 p-2 h-10 w-fit 
                      bg-transparent text-primary-900 hover:text-white hover:bg-primary-900 
                      border-2 rounded-lg 
                      text-base font-bold tracking-widest normal-case items-center
                      rounded-full shadow-md transition`;

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      navigate('/login');
    }
  };

  const handleResendActivation = () => {
    setShowResend(true);
  };

  const getStatusContent = () => {
    switch (status) {
      case 'success':
        return {
          icon: '🎉',
          title: 'Registration Successful!',
          message: 'Your account has been created successfully. Please check your email to activate your account.',
          color: 'text-green-600',
          bgColor: 'bg-green-50',
          borderColor: 'border-green-200'
        };
      case 'activated':
        return {
          icon: '✅',
          title: 'Account Activated!',
          message: 'Your account has been successfully activated. You can now log in to access your dashboard.',
          color: 'text-green-600',
          bgColor: 'bg-green-50',
          borderColor: 'border-green-200'
        };
      case 'pending':
      default:
        return {
          icon: '📧',
          title: 'Check Your Email',
          message: `We've sent an activation link to ${email}. Please check your inbox and click the link to activate your account.`,
          color: 'text-blue-600',
          bgColor: 'bg-blue-50',
          borderColor: 'border-blue-200'
        };
    }
  };

  const content = getStatusContent();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="modal-content w-full max-w-md p-6 bg-primary-100 white rounded-lg shadow-lg space-y-4 relative">
        <div className="w-full max-w-md p-6 rounded-lg shadow-lg space-y-4 bg-tertiary-600 relative">
          {/* Close button */}
          <button
            onClick={handleClose}
            className={`${buttonClass} absolute top-2 right-2 w-8 h-8 flex items-center justify-center z-20`}
            aria-label="Close"
            type="button"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          {/* Logo */}
          <div className="flex justify-center items-center">
            <Logo />
          </div>

          {/* Status Content */}
          <div className={`text-center p-6 rounded-lg border-2 ${content.bgColor} ${content.borderColor}`}>
            <div className="text-4xl mb-4">{content.icon}</div>
            <h2 className={`text-2xl font-bold mb-3 ${content.color}`}>
              {content.title}
            </h2>
            <p className="text-gray-700 text-base leading-relaxed mb-4">
              {content.message}
            </p>

            {/* Email Display */}
            {email && (
              <div className="bg-white p-3 rounded-lg border border-gray-200 mb-4">
                <p className="text-sm text-gray-600">Email sent to:</p>
                <p className="font-semibold text-gray-800">{email}</p>
              </div>
            )}

            {/* Action Buttons */}
            <div className="space-y-3">
              {status === 'pending' && (
                <>
                  <button
                    onClick={handleResendActivation}
                    className={`${buttonClass} w-full justify-center`}
                  >
                    Resend Activation Email
                  </button>
                  <button
                    onClick={() => navigate('/login')}
                    className={`${buttonClass} w-full justify-center`}
                  >
                    Go to Login
                  </button>
                </>
              )}
              
              {status === 'activated' && (
                <button
                  onClick={() => navigate('/login')}
                  className={`${buttonClass} w-full justify-center`}
                >
                  Login Now
                </button>
              )}

              {status === 'success' && (
                <button
                  onClick={handleClose}
                  className={`${buttonClass} w-full justify-center`}
                >
                  Got it!
                </button>
              )}
            </div>
          </div>

          {/* Help Section */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-sm font-semibold text-gray-800 mb-2">Need Help?</h3>
            <ul className="text-xs text-gray-600 space-y-1">
              <li>• Check your spam/junk folder</li>
              <li>• Make sure you entered the correct email address</li>
              <li>• Contact support if you don't receive the email within 5 minutes</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationStatus;
